import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  status: null,
  message: null,
  data: null
};

const userModuleReducer = createReducer(initialState, {
  USER_MODULE_REQ: (state) => {
    state.loading = true;
    state.data = null;
  },
  USER_MODULE_FETCH_SUC: (state, actions) => {
    const payload = actions.payload;
    state.loading = false;
    state.status = payload.status;
    state.message = payload.message;
    state.data = payload.data;
  },
  USER_MODULE_ERROR: (state, actions) => {
    state.loading = false;
    state.status = null;
    state.message = null;
    state.data = null;
  },
});

export default userModuleReducer;
